import { render, staticRenderFns } from "./ImageAttrMinimalism.vue?vue&type=template&id=059f62dc&scoped=true&"
import script from "./ImageAttrMinimalism.vue?vue&type=script&lang=js&"
export * from "./ImageAttrMinimalism.vue?vue&type=script&lang=js&"
import style0 from "./ImageAttrMinimalism.vue?vue&type=style&index=0&id=059f62dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059f62dc",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ObjectsPublicTheExportNew: require('/web/components/objects/public/TheExportNew.vue').default,TheBlockHeader: require('/web/components/TheBlockHeader.vue').default,AsyncObjectSnippetTooltip: require('/web/components/AsyncObjectSnippetTooltip.vue').default})
